export var AccountActionTypes;

(function (AccountActionTypes) {
  AccountActionTypes["REDIRECT"] = "REDIRECT";
  AccountActionTypes["USER_FLOW"] = "USER_FLOW";
  AccountActionTypes["DEBUG_MESSAGE"] = "DEBUG_MESSAGE";
  AccountActionTypes["NOTIFICATION"] = "NOTIFICATION";
})(AccountActionTypes || (AccountActionTypes = {}));
//# sourceMappingURL=AccountActionTypes.js.map